module.exports = __webpack_public_path__ + "static/media/header8.75c2f842.gif";